import { SVGs } from "../../assets";
import { Flex } from "antd";
import Text from "../text";
import React from "react";

const Checkbox = ({
  children,
  className = "",
  checked,
  onChange = () => {},
  ...props
}) => {
  return (
    <Flex
      gap={"1rem"}
      align="center"
      className={"cursor-pointer " + className}
      onClick={() => onChange({ target: { checked: !checked } })}
      {...props}
    >
      <img
        style={{ width: "2.2rem", height: "2.2rem" }}
        src={checked ? SVGs.checkboxActive : SVGs.checkboxInactive}
      />
      {children && <Text weight="600" color="secondary" children={children} />}
    </Flex>
  );
};

const Group = ({
  vertical = false,
  value = [],
  style,
  options = [],
  onChange = () => {},
  ...props
}) => {
  return (
    <Flex
      {...props}
      gap={"1rem"}
      vertical={vertical}
      children={React.Children.toArray(
        options.map((option) => {
          const checked = value.includes(option.value);
          return (
            <Checkbox
              checked={checked}
              children={option.label}
              onChange={() =>
                onChange(
                  checked
                    ? value.filter((_) => _ !== option.value)
                    : [...value, option.value]
                )
              }
            />
          );
        })
      )}
    />
  );
};

Checkbox.Group = Group;
export default Checkbox;
